export const inspectTable = [
  {
    content: "과업지시서, 계약서, 위탁협약서 등에 안전·보건   확보 의무사항 명시",
    isChecked: "",
    부서점검: "적정",
    중대재해예방팀: "적정",
  },
  {
    content: "‘협상의 의한 계약 제안서’ 평가 시 안전‧보건   확보 관련내용 포함",
    isChecked: "",
    부서점검: "적정",
    중대재해예방팀: "적정",
  },
  {
    content: "안전보건확보 의무이행 서약서",
    isChecked: "",
    부서점검: "적정",
    중대재해예방팀: "적정",
  },
  {
    content: "안전·보건 확보를 위한 관련비용 반영\n- 안전관리비, 산업안전보건관리비 등",
    isChecked: "",
    부서점검: "적정",
    중대재해예방팀: "적정",
  },
  {
    content: "안전·보건 수준평가\n- 적격 수급업체 선정 가이드라인",
    isChecked: "",
    부서점검: "적정",
    중대재해예방팀: "적정",
  },
  {
    content: "안전보건협의체 구성 및 운영 (월 1회)",
    isChecked: "",
    부서점검: "적정",
    중대재해예방팀: "적정",
  },
  {
    content: "작업장 순회 점검 (주 1회)",
    isChecked: "",
    부서점검: "적정",
    중대재해예방팀: "적정",
  },
  {
    content: "사업장 합동 안전보건 점검 실시 (분기별 1회 이상)",
    isChecked: "",
    부서점검: "적정",
    중대재해예방팀: "적정",
  },
  {
    content: "위험성 평가 및 유해·위험요인 개선 조치 여부",
    isChecked: "",
    부서점검: "적정",
    중대재해예방팀: "적정",
  },
  {
    content: "안전보건교육 장소 및 자료제공 등 협조 (수급인의 요구가 있는 경우)",
    isChecked: "",
    부서점검: "적정",
    중대재해예방팀: "적정",
  },
  {
    content: "수급인의 특별안전보건교육 실시여부 확인 (특별안전보건교육 대상 있는 경우)",
    isChecked: "",
    부서점검: "적정",
    중대재해예방팀: "적정",
  },
  {
    content: "안전·보건에 관한 정보제공 및 이행 확인 (화학물질, 질식, 붕괴 위험의 경우)",
    isChecked: "",
    부서점검: "적정",
    중대재해예방팀: "적정",
  },
  {
    content: "경보체계 운영과 대피방법 등 훈련 여부 (발파작업, 화재·폭발, 붕괴 등의 경우)",
    isChecked: "",
    부서점검: "적정",
    중대재해예방팀: "적정",
  },
  {
    content: "관계수급인 작업시기,내용 등 조정 (같은 장소에서 도급인과 수급인의 작업이 혼재하여 위험 발생 우려가 있는 경우)",
    isChecked: "",
    부서점검: "적정",
    중대재해예방팀: "적정",
  },
];
